import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import qs from 'querystring';
import liff from '@line/liff';
import { makeStyles } from '@material-ui/core/styles';
import { parseJwt } from '../../../app/utils';
import config from '../../../app/config';

const useStyles = makeStyles(
  {
    root: {
      textAlign: 'center',
    },
  },
  {
    name: 'LiffContainer',
  },
);

const LiffContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState('');
  const query = new URLSearchParams(location.search);

  // 處理liff 第一次進入Endpoint URL access_token會整合在liff.state參數
  const liffStateString = query.get('liff.state') || '';
  const liffState = decodeURI(liffStateString);
  const liffStateQuery = new URLSearchParams(liffState);
  const liffToken = liffStateQuery.get('access_token') || '';
  const { lineLiffId: liffLineLiffId } = parseJwt(liffToken) || {};

  // 處理liff 第二次進入Endpoint URL access_token會直接在Search Params中
  const token = query.get('access_token') || '';
  const {
    lineLiffId,
    lineChannelId,
    orgId: organizationId,
    provider,
  } = parseJwt(token) || {};

  // 處理解除封鎖後 -> Callback URL access_token會整合在state參數
  const stateString = query.get('state') || '';
  const stateQuery = new URLSearchParams(stateString);
  const stateToken = stateQuery.get('access_token') || '';
  const {
    lineLiffId: stateLineLiffId,
    lineChannelId: stateLineChannelId,
    orgId: stateOrganizationId,
  } = parseJwt(stateToken) || {};

  useEffect(() => {
    if (liffStateString) {
      liff
        .init({
          liffId: liffLineLiffId,
        })
        .catch(err => {
          setError(err?.message);
        });
    } else {
      liff
        .init({
          liffId: stateLineLiffId || lineLiffId,
        })
        .then(async () => {
          if (!liff.isLoggedIn()) {
            liff.login({
              redirectUri: `${config.ENDPOINT}/${provider}/liff${
                stateString || location.search
              }`,
            });
          } else {
            const profile = await liff.getProfile();
            const { friendFlag: isJoinedOA } = await liff.getFriendship();

            // Special case for 綠藤
            const isSpecialOrg =
              ~config.NOT_USED_JOINED_ORGANIZATION_LIST.indexOf(
                stateOrganizationId,
              ) ||
              ~config.NOT_USED_JOINED_ORGANIZATION_LIST.indexOf(organizationId);

            if (isSpecialOrg || isJoinedOA) {
              history.push(
                `/${provider}/terms${
                  stateString || location.search
                }&${qs.stringify({
                  customerId: profile?.userId,
                })}`,
              );
            } else {
              // Will be called only when Liff is authed and user not joined the OA
              const lineLoginURL =
                'https://access.line.me/oauth2/v2.1/authorize?';
              const queryString = qs.stringify({
                response_type: 'code',
                client_id: stateLineChannelId || lineChannelId,
                redirect_uri: encodeURI(`${config.ENDPOINT}/${provider}/liff`),
                state: stateString || location.search,
                scope: 'openid profile',
                prompt: 'consent',
                bot_prompt: 'aggressive',
              });
              window.location.href = lineLoginURL + queryString;
            }
          }
        })
        .catch(err => {
          setError(err?.message);
        });
    }
  }, []);

  return <div className={classes.root}>{error}</div>;
};

export default LiffContainer;
